/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevertAdmissionStatusRequest
 */
export interface RevertAdmissionStatusRequest {
    /**
     * ID of the current admission-status history row the user confirmed. The revert is rejected when the lead's current row differs.
     */
    expected_admission_status_info_id?: string;
}

/**
 * Check if a given object implements the RevertAdmissionStatusRequest interface.
 */
export function instanceOfRevertAdmissionStatusRequest(value: object): value is RevertAdmissionStatusRequest {
    return true;
}

export function RevertAdmissionStatusRequestFromJSON(json: any): RevertAdmissionStatusRequest {
    return RevertAdmissionStatusRequestFromJSONTyped(json, false);
}

export function RevertAdmissionStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevertAdmissionStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expected_admission_status_info_id': json['expected_admission_status_info_id'] == null ? undefined : json['expected_admission_status_info_id'],
    };
}

export function RevertAdmissionStatusRequestToJSON(json: any): RevertAdmissionStatusRequest {
    return RevertAdmissionStatusRequestToJSONTyped(json, false);
}

export function RevertAdmissionStatusRequestToJSONTyped(value?: RevertAdmissionStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expected_admission_status_info_id': value['expected_admission_status_info_id'],
    };
}

